module.exports = __webpack_public_path__ + "img/ill_badge_success.1f82d7fd.svg";